import { render, staticRenderFns } from "./ProxyPackageAddDialog.vue?vue&type=template&id=8773e324"
import script from "./ProxyPackageAddDialog.vue?vue&type=script&lang=js"
export * from "./ProxyPackageAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports